/**
 * @format
 */

import AsyncStorage from "./AsyncStorage";

export default AsyncStorage;
export { useAsyncStorage } from "./hooks";
